<div class="monthly-schedule mb-4">
    <div class="cal-header">
        <div class="cal-nav previous" (click)="onPrevMonth()">
            <i class="fas fa-angle-left"></i>{{'Previous' | translate}}
        </div>

        <div>
            <h5 class="cal-nav">{{selectedDriver.firstName}} {{selectedDriver.lastname}},
                {{daysInMonth[0] | amLocale: locale | amDateFormat:'MMMM YYYY' }}
            </h5>
            <button (click)="onClose()"
                class="btn btn-xs pd-x-15 btn-uppercase mg-l-5 btn-white btn-hide-schedule">{{'Hide schedule' |
                translate}}</button>
        </div>
        <div class="cal-nav next" (click)="onNextMonth()">
            {{'Next' | translate}} <i class="fas fa-angle-right"></i>
        </div>
    </div>

    <table class="table text-center month-schedule">
        <ng-container *ngFor="let sliceStart of daySlices">
            <thead>
                <tr class="text-center">
                    <th *ngFor="let day of daysInMonth.slice(sliceStart, sliceStart + 10)">{{day | amLocale: locale |
                        amDateFormat:'D.MM' }}</th>
                </tr>
                <tr class="text-center shift-names-row">
                    <th *ngFor="let day of daysInMonth.slice(sliceStart, sliceStart + 10)">
                        <div class="shifts" *ngIf="findShifts(day) as dayShifts">
                            <span class="shift-label" *ngFor="let type of dayShifts.shifts"
                                [containerClass]="'pretty-tooltip'" [tooltip]="(type | translate)">{{ type | shiftLabelShort:5 }}</span>
                        </div>
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td *ngFor="let day of daysInMonth.slice(sliceStart, sliceStart + 10)">
                        <div class="shifts" [style.height.%]="100">

                            <ng-container *ngIf="findShifts(day) as dayShifts">

                                <div *ngFor="let type of dayShifts.shifts" class="shift-type text-center"
                                    [containerClass]="'pretty-tooltip'" [tooltip]="(type | translate)"
                                    (click)="onChange(selectedDriver.id, dayShifts.date, type, warehouse)"
                                    [style.height.%]="100">
                                    <ng-container
                                        *ngTemplateOutlet="availabilityTemplate; context: {$implicit:isAvailable(selectedDriver.id, dayShifts.date, type)}"></ng-container>

                                    <ng-template #availabilityTemplate let-default>
                                        <div *ngIf="default && default.mode === 'SERVICE'"
                                            class="driver-availability active service">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="settings"></i-feather>
                                        </div>
                                        <div *ngIf="default && (default.mode === 'REGULAR' || default.mode === null)"
                                            class="driver-availability active regular">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="truck"></i-feather>
                                        </div>
                                        <div *ngIf="default && (default.mode === 'VACATION' || default.mode === null)"
                                            class="driver-availability vacation">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="sun"></i-feather>
                                        </div>
                                        <div *ngIf="default && (default.mode === 'SICKLEAVE' || default.mode === null)"
                                            class="driver-availability sickleave">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="thermometer"></i-feather>
                                        </div>
                                        <div *ngIf="default && (default.mode === 'SUPPLY' || default.mode === null)"
                                            class="driver-availability supply">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="clipboard"></i-feather>
                                        </div>
                                        <div *ngIf="!default" class="driver-availability">
                                            <i-feather [style.width.px]="18" [style.height.px]="18"
                                                name="x"></i-feather>
                                        </div>
                                    </ng-template>


                                </div>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </tbody>
        </ng-container>
    </table>
</div>
